import { ReactNode } from 'react';

import { Field, FieldProps } from 'react-final-form';

import { TimeInput, TimeInputProps } from '@cast/design-system';

import { useControlsGroupState } from './controls-state';
import { useRffFormState } from '../hooks';
import { showErrorOnChange } from '../utils';

type Props = Omit<TimeInputProps, 'value' | 'onBlur' | 'onChange'> & {
  name: string;
  size?: 'small' | 'medium' | 'large';
  renderError?: (error: string | string[]) => ReactNode;
  fieldProps?: Partial<FieldProps<string, any>>;
};

export const RffTimeInput = ({
  fieldProps = {},
  renderError,
  InputProps = {},
  name,
  ...inputProps
}: Props) => {
  const { mode } = useRffFormState();
  const { disabled, readOnly } = useControlsGroupState({
    disabled: inputProps.disabled,
    readOnly: mode === 'view' || inputProps.readOnly,
  });

  return (
    <Field
      {...fieldProps}
      name={name}
      render={(props) => {
        const {
          input: { onBlur, onFocus, onChange, value },
          meta,
        } = props;
        const showError = showErrorOnChange(meta);
        return (
          <TimeInput
            onChange={onChange}
            value={value}
            error={
              showError ? renderError?.(meta.error) || meta.error : undefined
            }
            {...inputProps}
            InputProps={{
              onBlur,
              onFocus,
              min: 0,
              ...InputProps,
              success: meta.touched && meta.valid,
            }}
            readOnly={readOnly}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
